import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    & > thead {
        box-sizing: unset;
    }
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        border: 1px solid #ddd;
        border-collapse: collapse;
        font-size: ${p => p.fontSize ? p.fontSize : null};
    }

    & > tbody > tr > td {
        vertical-align: middle;
    }
`;


export const GridWrapper = styled.div`
    height: 80vh;
    
    font-family: Roboto;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 4px;
        color: #fff;
        border-left: 1px solid white;
    }

    .group-header {
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: #eee;
        border-width: 1px 0px 1px 1px;
        border-style: solid;
        font-weight: 500;
    }

    .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }


    .header-row-span-new {
    background-color: #133366 !important;
    color: white !important;
    text-align: center;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px; /* Matches your grid header */
    border-left: 1px solid white;
    border-right: 1px solid #ccc;
    vertical-align: middle;
}



    .header-row-span-2 {
        position: fixed;
        top: 0px;
        height: 70px;
        color: white;
        text-align: center;
        display: flex;
        justify-content: center;
        border-left: 1px solid white;
    }

    .header-row-span-2-left-right {
        position: fixed;
        top: 0px;
        height: 70px;
        color: white;
        text-align: center;
        display: flex;
        justify-content: center;
        border-left: 1px solid white;
        border-right: 1px solid white;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }
`;